// elementRuns — the document's elements cut into runs of consecutive
// same-kind blocks, pure. Each block keeps its document index (the move
// contract is index-based), so grouping never changes what a block does.

import type { Element } from "../types.js";

export type ElementRun = {
    readonly kind: Element["type"];
    readonly items: readonly {
        readonly element: Element;
        readonly index: number;
    }[];
};

export const elementRuns = (
    elements: readonly Element[],
): readonly ElementRun[] =>
    elements.reduce<readonly ElementRun[]>((runs, element, index) => {
        const last = runs.at(-1);
        return last !== undefined && last.kind === element.type
            ? [
                  ...runs.slice(0, -1),
                  { ...last, items: [...last.items, { element, index }] },
              ]
            : [...runs, { kind: element.type, items: [{ element, index }] }];
    }, []);
